// queries/useInstanceStates.ts
"use client";
import { fetch } from "libs";
import { GET_INSTANCE_STATES } from "api";
import { useQuery } from "@tanstack/react-query";

export const fetchInstanceStates = async (): Promise<
  Record<string, Record<string, Record<string, Record<string, unknown>>>>
> => {
  return await fetch(GET_INSTANCE_STATES, {
    method: "GET",
  });
};

const useInstanceStates = () =>
  useQuery({
    queryKey: ["useInstanceStates"],
    queryFn: async () => {
      return await fetchInstanceStates();
    },
    enabled: typeof window === "object",
    refetchInterval: 5000,
  });

export default useInstanceStates;
